import { CommunicationService } from './../services/communication.service';
import { PreRenderService } from './../services/pre-render.service';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { ListingCategory } from '../classes/enums';
import { CookieService } from 'ngx-cookie';
import { map, take } from 'rxjs/operators';

declare function g_activateSplashAnimation();

const SEEN_SPLASH_COOKIE = "hss";

@Injectable()
export class SplashIntroResolver implements Resolve<boolean> {

  constructor(private preRenderService: PreRenderService
    , private communicationService: CommunicationService
    , private cookieService: CookieService
    ) { }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<boolean> {

    return this.communicationService.listings.currentShownListingType.pipe(
        take(1),
        map((type) => {
            if (type == ListingCategory.RESIDENTIAL
                 && this.preRenderService.isBrowserMode
                 && !this.cookieService.get(SEEN_SPLASH_COOKIE)
                 && !!g_activateSplashAnimation
                ) {
                g_activateSplashAnimation();
                this.cookieService.put(SEEN_SPLASH_COOKIE, "1");
            }
            return true;
        }))
    ;
  }
}